// src/App.jsx
import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Sidebar from './Components/Sidebar';
import Roulette from './Components/Roulette';
import MainContent from './Components/MainContent';
import Login from './Components/Login';
import Register from './Components/Register';
import Personal from './Components/Personal';
import { DessertDataContext } from './contextsGlobal/dessertDataContext';
import Account from './Components/Account';
import ProtectedRoute from './Components/ProtectedRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './App.css';

function App() {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFlavor, setSelectedFlavor] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [selectedDietary, setSelectedDietary] = useState([]);
  const [selectedRating, setSelectedRating] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
    const handleResize = () => {
      if (headerRef.current) {
        setHeaderHeight(headerRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev);
  };

  return (
    <BrowserRouter>
      <DessertDataContext>
        <div className="app-container">
          <Header
            ref={headerRef}
            onSearchChange={setSearchQuery}
            isLoggedIn={isLoggedIn}
            setIsLoggedIn={setIsLoggedIn}
            toggleSidebar={toggleSidebar}
          />
          <div className={`content-area ${showSidebar ? 'sidebar-open' : ''}`}>
            {showSidebar && (
              <div className="sidebar visible">
                <Sidebar 
                  selectedFlavor={selectedFlavor}
                  setSelectedFlavor={setSelectedFlavor}
                  selectedType={selectedType}
                  setSelectedType={setSelectedType}
                  selectedDietary={selectedDietary}
                  setSelectedDietary={setSelectedDietary}
                  selectedRating={selectedRating}
                  setSelectedRating={setSelectedRating}
                />
              </div>
            )}
            <div className="main-content-wrapper">
              <Routes>
                <Route
                  path="/" 
                  element={
                    <MainContent 
                      searchQuery={searchQuery}
                      selectedFlavor={selectedFlavor}
                      selectedType={selectedType}
                      selectedDietary={selectedDietary}
                      selectedRating={selectedRating}
                    />
                  } 
                />
                <Route path="/roulette" element={<Roulette />} />
                <Route path="/account" element={<Account />} />
                <Route
                  path="/personal"
                  element={
                    <ProtectedRoute isLoggedIn={isLoggedIn}>
                      <Personal />
                    </ProtectedRoute>
                  }
                />
                <Route path="/login" element={isLoggedIn ? <Navigate to="/" /> : <Login setIsLoggedIn={setIsLoggedIn} />} />
                <Route path="/register" element={isLoggedIn ? <Navigate to="/" /> : <Register />} />
              </Routes>
            </div>
          </div>
          <Footer />
        </div>
      </DessertDataContext>
    </BrowserRouter>
  );
}

export default App;